import React, { useState } from 'react';

function SurveyStepTwentySix({ formData, onNext }) {
    const [stressFrequency, setStressFrequency] = useState(formData.stressFrequency || '');
    const [stressComments, setStressComments] = useState(formData.stressComments || '');
    const [error, setError] = useState('');

    const handleContinue = () => {
        if (!stressFrequency) {
            setError('Please select a rating.');
            return;
        }
        setError('');
        onNext({ stressFrequency, stressComments });
    };

    const ratingOptions = ['N/A', ...Array.from({ length: 10 }, (_, i) => (i + 1).toString())];

    return (
        <div className="step-form">
            <h6 className="mb-4">Section 6: Employee Well-being</h6>

            {error && <div className="alert alert-danger">{error}</div>}

            <label className="form-label">
                How often do you feel stressed at work? <span className="text-danger">*</span>
            </label>

            <div className="d-flex flex-wrap gap-2 mb-4 justify-content-around">
                {ratingOptions.map((option) => (
                    <div key={option} className="form-check rating_btn">
                        <input
                            type="radio"
                            id={`stress-frequency-${option}`}
                            name="stressFrequency"
                            value={option}
                            checked={stressFrequency === option}
                            onChange={() => setStressFrequency(option)}
                        />
                        <label htmlFor={`stress-frequency-${option}`}>{option}</label>
                    </div>
                ))}
            </div>

            <div className="mb-3">
                <label className="form-label">Additional comments (optional):</label>
                <textarea
                    className="form-control"
                    rows="4"
                    value={stressComments}
                    onChange={(e) => setStressComments(e.target.value)}
                    placeholder="Share any additional thoughts here..."
                />
            </div>

            <div className="text-end mt-5">
                <button
                    className="btn btn-dark px-4"
                    onClick={handleContinue}
                    disabled={!stressFrequency}
                >
                    Next
                </button>
            </div>
        </div>
    );
}

export default SurveyStepTwentySix;
